/**
 * Unabhängige Judikatur-Suche (Anwaltssuche).
 * Gleicher JUD-HTTP wie Fall-Join, aber **kein** lexCarry / Combined-Block.
 * Premium-IF in n8n vor dem Call. Kein `rechtsgebiet` im Body.
 */

export const JUD_SEARCH_ANSWER_PATH = '/v1/jud/answer';
export const JUD_SEARCH_DEFAULT_TOP_K = 5;
export const JUD_SEARCH_INTENT = 'judicature_recherche' as const;
export const JUD_SEARCH_KIND = 'lawyer_search' as const;

/** Freitext der Suchleiste → Chat-Input. Leer/Whitespace = kein Call. */
export function buildJudSearchLookupPrompt(query: string): string | null {
  const q = query.replace(/\s+/g, ' ').trim();
  if (!q) return null;
  return q.slice(0, 1000);
}

export function judSearchLookupRequest(query: string): {
  intent: typeof JUD_SEARCH_INTENT;
  judicatureMode: true;
  chatInput: string;
} | null {
  const chatInput = buildJudSearchLookupPrompt(query);
  if (!chatInput) return null;
  return {
    intent: JUD_SEARCH_INTENT,
    judicatureMode: true,
    chatInput,
  };
}
